import type { RouteRecordRaw } from 'vue-router';

/**
 * Rotas disponíveis para as opções públicas da empresa
 * - Negócio
 * - Simulação
 */
export const companyRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PublicCompanyLayout',
    path: '/links',
    props: false,
    meta: { requiresAuth: false },
    component: () => import('@/views/public/PublicLayout.vue'),
    children: [
      {
        name: 'PublicLinks',
        path: ':username',
        props: true,
        component: () => import('@/views/public/company/PublicLinks.vue'),
        meta: { requiresAuth: false },
      },
    ],
  },
];
